import React, { useMemo } from 'react';
import classnames from 'classnames';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import CommonSourceCard from '@gp/components/CommonSourceCard';

import './index.scss';

const MetricsCard3: React.FC<IMetricsCard3Props> = (props) => {
  const { title, date, icon, value, ratio, metrics = [], ...restProps } = props;

  const isNoData = useMemo<boolean>(() => {
    const flag1 = value === '-';
    const flag2 = ratio === 0;
    const flag3 = metrics?.length === 0 || metrics?.every((metric) => metric?.metricValue === '-');
    return flag1 && flag2 && flag3;
  }, [value, ratio, metrics]);

  const renderCardContent = () => (
    <div className="dbg-studio-overall-metrics-card3">
      <ul className="dbg-studio-overall-metrics-card3-list">
        {metrics?.length > 0 &&
          metrics?.map((metric) => (
            <li
              key={metric?.metricName}
              className={classnames('dbg-studio-overall-metrics-card3-item', {
                'growth-item': !!metric?.isGrowth,
              })}
            >
              <div className="dbg-studio-overall-metrics-card3-item-title">
                <EllipsisTextBubble text={metric?.metricName || ''} />
              </div>
              <div className="dbg-studio-overall-metrics-card3-item-value">{metric?.metricValue}</div>
            </li>
          ))}
      </ul>
    </div>
  );

  return (
    <CommonSourceCard
      {...restProps}
      percentLabel="YoY"
      title={title}
      date={date}
      icon={icon}
      value={value as string}
      percentV={ratio}
      isNoData={isNoData}
      // @ts-ignore
      isPercentage={!Number.isNaN(Number.parseFloat(ratio)) && Number.parseFloat(ratio) !== 0}
      slot={renderCardContent()}
    />
  );
};

export default React.memo(MetricsCard3);
